import Utils from '@lcsc-ui/utils/Utils';

export function getCatalogSchema(catalogResResult, resourceData) {
  const { searchResult } = catalogResResult || {};
  const { projectConfigVO } = resourceData || {};

  const numberOfItems = `${searchResult?.totalCount || 0}`;

  let itemListElement = [];
  if (searchResult?.productRecordList?.length > 0) {
    const list = searchResult.productRecordList.slice(0, 3);
    itemListElement = list.map((item, index) => {
      // 详情页
      const url = `${projectConfigVO?.lcscItemUrl}/${item?.isMro ? 'mro/' : ''}${item?.productVO?.productId}.html`;
      // 单价
      const price = item?.productVO?.productPriceList?.[0]?.thePrice || '';
      // 是否有货
      const availability =
        item?.productVO?.hasStockNow === 'yes' ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item?.isMro ? item?.productVO?.productName : item?.productVO?.productModel,
          image: item?.productVO?.breviaryImageUrl,
          description: item?.remarkPrefixTitle,
          brand: {
            '@type': 'Brand',
            name: item?.productVO?.productGradePlateName,
          },
          offers: {
            '@type': 'Offer',
            url,
            priceCurrency: 'CNY',
            price,
            availability,
          },
        },
      };
    });
  }

  const description = `立创商城-专业的${searchResult?.currentCatalog?.catalogName}现货采购平台,为您提供${numberOfItems}种${searchResult?.currentCatalog?.catalogName}价格行情,参数,封装规格,厂家品牌,数据手册,现货库存等信息,采购${searchResult?.currentCatalog?.catalogName}上立创商城。`;

  const JsonLd = {
    '@context': 'http://schema.org',
    '@type': 'Catalog',
    name: searchResult?.currentCatalog?.catalogName,
    url: searchResult?.currentCatalog?.catalogConfigUrl,
    description,
    numberOfItems,
    itemListElement,
  };

  const MicroData = (
    <div itemscope itemType="https://schema.org/Catalog">
      <meta itemprop="name" content={searchResult?.currentCatalog?.catalogName}></meta>
      <meta itemprop="url" content={searchResult?.currentCatalog?.catalogConfigUrl}></meta>
      <meta itemprop="description" content={description}></meta>
      <meta itemprop="numberOfItems" content={numberOfItems}></meta>

      {itemListElement?.map((el, index) => (
        <div itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" key={index}>
          <meta itemprop="position" content={el?.position} />
          <div itemprop="item" itemscope itemtype="https://schema.org/Product">
            <meta itemprop="name" content={el?.item?.name}></meta>
            <meta itemprop="image" content={el?.item?.image}></meta>
            <meta itemprop="description" content={el?.item?.description}></meta>
            <div itemprop="brand" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="name" content={el?.item?.brand?.name}></meta>
            </div>
            <div itemprop="offers" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="url" content={el?.item?.offers?.url}></meta>
              <meta itemprop="priceCurrency" content={el?.item?.offers?.priceCurrency}></meta>
              <meta itemprop="price" content={el?.item?.offers?.price}></meta>
              <meta itemprop="availability" content={el?.item?.offers?.availability}></meta>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return {
    JsonLd,
    MicroData,
  };
}

export function getBrandSchema(brandResult, resourceData, catalog, noIndex) {
  const { searchResult } = brandResult || {};
  const { projectConfigVO } = resourceData || {};

  const numberOfItems = `${searchResult?.totalCount || 0}`;

  let itemListElement = [];
  if (searchResult?.productRecordList?.length > 0) {
    const list = searchResult.productRecordList.slice(0, 3);
    itemListElement = list.map((item, index) => {
      // 详情页
      let url = `${projectConfigVO?.lcscItemUrl}/${item?.isMro ? 'mro/' : ''}${item?.productVO?.productId}.html`;
      if (item?.track_zone) {
        const splitor = url.includes('?') ? '&' : '?';
        url += `${splitor}fromZone=${Utils.safeEncodeURI(item?.track_zone)}`;
      }
      // 单价
      const price = item?.productVO?.productPriceList?.[0]?.thePrice || '';
      // 是否有货
      const availability =
        item?.productVO?.hasStockNow === 'yes' ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item?.isMro ? item?.productVO?.productName : item?.productVO?.productModel,
          image: item?.productVO?.breviaryImageUrl,
          description: item?.remarkPrefixTitle,
          brand: {
            '@type': 'Brand',
            name: item?.productVO?.productGradePlateName,
          },
          offers: {
            '@type': 'Offer',
            url,
            priceCurrency: 'CNY',
            price,
            availability,
          },
        },
      };
    });
  }

  const description = `立创商城提供${searchResult?.currentBrand?.productGradePlateName}公司介绍和产品供应信息，包括产品型号、参数、最新价格和库存查询，产品覆盖${catalog}等，购买${searchResult?.currentBrand?.productGradePlateName}产品上立创商城，正品保证`;

  const url = noIndex
    ? `${resourceData?.projectConfigVO?.lcscListUrl}/brand/${searchResult?.currentBrand?.productGradePlateId}.html`
    : searchResult?.currentBrand?.companyWebsite;

  const JsonLd = {
    '@context': 'http://schema.org',
    '@type': 'Brand',
    name: searchResult?.currentBrand?.productGradePlateName,
    url,
    logo: searchResult?.currentBrand?.logoUrl,
    description,
    numberOfItems,
    itemListElement,
  };
  const MicroData = (
    <div itemscope itemType="https://schema.org/Brand">
      <meta itemprop="name" content={searchResult?.currentBrand?.productGradePlateName}></meta>
      <meta itemprop="url" content={url}></meta>
      <meta itemprop="logo" content={searchResult?.currentBrand?.logoUrl}></meta>
      <meta itemprop="description" content={description}></meta>
      <meta itemprop="numberOfItems" content={numberOfItems}></meta>
      {itemListElement?.map((el, index) => (
        <div itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" key={index}>
          <meta itemprop="position" content={el?.position} />
          <div itemprop="item" itemscope itemtype="https://schema.org/Product">
            <meta itemprop="name" content={el?.item?.name}></meta>
            <meta itemprop="image" content={el?.item?.image}></meta>
            <meta itemprop="description" content={el?.item?.description}></meta>
            <div itemprop="brand" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="name" content={el?.item?.brand?.name}></meta>
            </div>
            <div itemprop="offers" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="url" content={el?.item?.offers?.url}></meta>
              <meta itemprop="priceCurrency" content={el?.item?.offers?.priceCurrency}></meta>
              <meta itemprop="price" content={el?.item?.offers?.price}></meta>
              <meta itemprop="availability" content={el?.item?.offers?.availability}></meta>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return {
    JsonLd,
    MicroData,
  };
}
export function getCouponSchema(couponResult, resourceData) {
  const { searchResult } = couponResult || {};
  const { projectConfigVO } = resourceData || {};

  const numberOfItems = `${searchResult?.totalCount || 0}`;

  let itemListElement = [];
  if (searchResult?.productRecordList?.length > 0) {
    const list = searchResult.productRecordList.slice(0, 3);
    itemListElement = list.map((item, index) => {
      // 详情页
      const url = `${projectConfigVO?.lcscItemUrl}/${item?.isMro ? 'mro/' : ''}${item?.productVO?.productId}.html`;
      // 单价
      const price = item?.productVO?.productPriceList?.[0]?.thePrice || '';
      // 是否有货
      const availability =
        item?.productVO?.hasStockNow === 'yes' ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item?.isMro ? item?.productVO?.productName : item?.productVO?.productModel,
          image: item?.productVO?.breviaryImageUrl,
          description: item?.remarkPrefixTitle,
          brand: {
            '@type': 'Brand',
            name: item?.productVO?.productGradePlateName,
          },
          offers: {
            '@type': 'Offer',
            url,
            priceCurrency: 'CNY',
            price,
            availability,
          },
        },
      };
    });
  }

  const description = `立创商城提供${searchResult?.currentBrand?.productGradePlateName}公司介绍和产品供应信息，包括产品型号、参数、最新价格和库存查询，产品覆盖等，购买${searchResult?.currentBrand?.productGradePlateName}产品上立创商城，正品保证`;

  const JsonLd = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    name: searchResult?.currentBrand?.productGradePlateName,
    url: searchResult?.currentBrand?.companyWebsite,
    logo: searchResult?.currentBrand?.logoUrl,
    description,
    numberOfItems,
    itemListElement,
  };
  const MicroData = (
    <div itemscope itemType="https://schema.org/Brand">
      <meta itemprop="name" content={searchResult?.currentBrand?.productGradePlateName}></meta>
      <meta itemprop="url" content={searchResult?.currentBrand?.companyWebsite}></meta>
      <meta itemprop="logo" content={searchResult?.currentBrand?.logoUrl}></meta>
      <meta itemprop="description" content={description}></meta>
      <meta itemprop="numberOfItems" content={numberOfItems}></meta>
      {itemListElement?.map((el, index) => (
        <div itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" key={index}>
          <meta itemprop="position" content={el?.position} />
          <div itemprop="item" itemscope itemtype="https://schema.org/Product">
            <meta itemprop="name" content={el?.item?.name}></meta>
            <meta itemprop="image" content={el?.item?.image}></meta>
            <meta itemprop="description" content={el?.item?.description}></meta>
            <div itemprop="brand" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="name" content={el?.item?.brand?.name}></meta>
            </div>
            <div itemprop="offers" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="url" content={el?.item?.offers?.url}></meta>
              <meta itemprop="priceCurrency" content={el?.item?.offers?.priceCurrency}></meta>
              <meta itemprop="price" content={el?.item?.offers?.price}></meta>
              <meta itemprop="availability" content={el?.item?.offers?.availability}></meta>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return {
    JsonLd,
    MicroData,
  };
}

export function getTiSchema(lcbookData, resourceData) {
  const { lcbookLandingPageProductVOS, totalRow } = lcbookData || {};
  const { projectConfigVO } = resourceData || {};

  const numberOfItems = `${totalRow || 0}`;

  let itemListElement = [];
  if (lcbookLandingPageProductVOS?.length > 0) {
    const list = lcbookLandingPageProductVOS.slice(0, 3);
    itemListElement = list.map((item, index) => {
      // 详情页
      const url = `${projectConfigVO?.lcscItemUrl}/details/${item?.provider}/${item?.productCodeProvider}`;
      // 单价
      const price = item?.tieredPrices?.[0]?.price || '';
      // 是否有货
      const availability = item?.stockNumber > 0 ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item?.productCodeManufacturer,
          image: 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/ti_new.png',
          description: item?.productDesc,
          brand: {
            '@type': 'Brand',
            name: item?.brandName,
          },
          offers: {
            '@type': 'Offer',
            url,
            priceCurrency: 'CNY',
            price,
            availability,
          },
        },
      };
    });
  }

  const description = `立创商城推出TI德州仪器元器件期货订货专属福利活动，提供MCU、电源IC、运放等TI德州仪器10万+芯片直供服务，热门冷门型号均可排单。单笔满2万元送2%采购晶，按需提货更灵活。官方合作渠道，原厂正品保障。`;

  const JsonLd = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    name: 'TI德州仪器元器件列表',
    description,
    numberOfItems,
    itemListElement,
  };
  const MicroData = (
    <div itemscope itemType="https://schema.org/Brand">
      <meta itemprop="name" content={'TI德州仪器元器件列表'}></meta>
      <meta itemprop="description" content={description}></meta>
      <meta itemprop="numberOfItems" content={numberOfItems}></meta>
      {itemListElement?.map((el, index) => (
        <div itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" key={index}>
          <meta itemprop="position" content={el?.position} />
          <div itemprop="item" itemscope itemtype="https://schema.org/Product">
            <meta itemprop="name" content={el?.item?.name}></meta>
            <meta itemprop="image" content={el?.item?.image}></meta>
            <meta itemprop="description" content={el?.item?.description}></meta>
            <div itemprop="brand" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="name" content={el?.item?.brand?.name}></meta>
            </div>
            <div itemprop="offers" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="url" content={el?.item?.offers?.url}></meta>
              <meta itemprop="priceCurrency" content={el?.item?.offers?.priceCurrency}></meta>
              <meta itemprop="price" content={el?.item?.offers?.price}></meta>
              <meta itemprop="availability" content={el?.item?.offers?.availability}></meta>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return {
    JsonLd,
    MicroData,
  };
}

export function getCommonSchema(productResult, resourceData, description) {
  const { searchResult } = productResult || {};
  const { projectConfigVO } = resourceData || {};

  const numberOfItems = `${searchResult?.totalCount || 0}`;

  let itemListElement = [];
  if (searchResult?.productRecordList?.length > 0) {
    const list = searchResult.productRecordList.slice(0, 3);
    itemListElement = list.map((item, index) => {
      // 详情页
      const url = `${projectConfigVO?.lcscItemUrl}/${item?.isMro ? 'mro/' : ''}${item?.productVO?.productId}.html`;
      // 单价
      const price = item?.productVO?.productPriceList?.[0]?.thePrice || '';
      // 是否有货
      const availability =
        item?.productVO?.hasStockNow === 'yes' ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item?.isMro ? item?.productVO?.productName : item?.productVO?.productModel,
          image: item?.productVO?.breviaryImageUrl,
          description: item?.remarkPrefixTitle,
          brand: {
            '@type': 'Brand',
            name: item?.productVO?.productGradePlateName,
          },
          offers: {
            '@type': 'Offer',
            url,
            priceCurrency: 'CNY',
            price,
            availability,
          },
        },
      };
    });
  }

  const JsonLd = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    description,
    numberOfItems,
    itemListElement,
  };

  const MicroData = (
    <div itemscope itemType="https://schema.org/ItemList">
      <meta itemprop="description" content={description}></meta>
      <meta itemprop="numberOfItems" content={numberOfItems}></meta>

      {itemListElement?.map((el, index) => (
        <div itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" key={index}>
          <meta itemprop="position" content={el?.position} />
          <div itemprop="item" itemscope itemtype="https://schema.org/Product">
            <meta itemprop="name" content={el?.item?.name}></meta>
            <meta itemprop="image" content={el?.item?.image}></meta>
            <meta itemprop="description" content={el?.item?.description}></meta>
            <div itemprop="brand" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="name" content={el?.item?.brand?.name}></meta>
            </div>
            <div itemprop="offers" itemscope itemtype="https://schema.org/Brand">
              <meta itemprop="url" content={el?.item?.offers?.url}></meta>
              <meta itemprop="priceCurrency" content={el?.item?.offers?.priceCurrency}></meta>
              <meta itemprop="price" content={el?.item?.offers?.price}></meta>
              <meta itemprop="availability" content={el?.item?.offers?.availability}></meta>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return {
    JsonLd,
    MicroData,
    description,
  };
}
